export default "__VITE_ASSET__rXegLk2B__"